import { Group, Member } from '../../../../../api/groups';
import ListGroup from './students-content/ListGroup';
import ListGroupSmartschool from './students-content/ListGroupSmartschool';
import { SchoolYear } from '../../../context/MyGroupsContext';

type Props = {
  group: Group;
  members: Member[];
  schoolYear: SchoolYear;
  setMembers: (members: Member[]) => void;
};

function StudentsContent({ group, members, schoolYear, setMembers }: Props) {
  if (!!group.smartschoolGroupId) {
    return <ListGroupSmartschool group={group} members={members} />;
  }

  return <ListGroup group={group} members={members} schoolYear={schoolYear} setMembers={setMembers} />;
}

export default StudentsContent;
